namespace JupitersChoice {
    export class Reels extends Sapphire.Reels {

        @inject('StateModel') _stateModel: Sapphire.StateModel;

        constructor() {
            super();
        }

        construct(data: any) {
            super.construct(data);
        }

        setOrientation(orientation: string): void {
            this.x = this['data'].position[orientation].x;
            this.y = this['data'].position[orientation].y;

            this.scale.x = this['data'].scale[orientation].x;
            this.scale.y = this['data'].scale[orientation].y;

            if (this._stateModel.currentSubgame === 'FreeGame' && orientation === 'portrait') {
                this.y += 193;
            }
        }
    }
}